import { Button, Color, IconArrowRight, Loader } from '@insurely/ui';

import { useIntl } from 'react-intl';

import { BaseView } from '@main/components/BaseView';

import { InsuranceDetails } from '@main/components/InsuranceDetails';
import {
  BlocksModule,
  useFlatPolicies,
  useIsPossibleToCompare,
  useNavigate,
  useSearchParams,
  useSharedData,
  useUseCase,
} from '@main/shared-exports';

import { getInsuranceDetailsLabels } from '@main/utils/getInsuranceDetailsLabels';

import styles from './insuranceDetailsView.module.css';

export const InsuranceDetailsView = () => {
  const intl = useIntl();
  const [searchParams] = useSearchParams();
  const externalId = searchParams.get('externalId') ?? undefined;

  const { skipBlock, currentModule } = useUseCase();
  const skipIsCompare = currentModule.skip === BlocksModule.Compare;
  const [
    {
      clientConfig: {
        productConfigs,
        market: { country },
      },
    },
    { selectPolicy },
  ] = useSharedData();
  const navigate = useNavigate();

  const insurancePolicies = useFlatPolicies();
  const policy = insurancePolicies.find((res) => res.insurance?.externalId === externalId);

  const isPossibleToCompare = useIsPossibleToCompare();
  const { isComparisonPossible } = isPossibleToCompare(policy as InsurancePolicy);

  if (!policy?.insurance) {
    return <Loader.Content />;
  }

  const { insurance } = policy;

  const insuranceDetailsCopy = getInsuranceDetailsLabels({ intl, insurance, country });

  const offerCompanyDisplayName =
    productConfigs?.compare?.offerCompany?.displayName ??
    productConfigs?.checkout?.selectedCheckout?.insuranceCompanyDisplayName ??
    '';

  const onClick = () => {
    selectPolicy(policy);
    skipBlock({ urlQueryParams: { externalId: insurance.externalId } });
  };

  return (
    <BaseView>
      <InsuranceDetails
        externalId={externalId}
        isComparisonPossible={isComparisonPossible}
        topContent={
          isComparisonPossible && skipIsCompare ? (
            <Button fullWidth style={{ margin: '8px auto 40px' }} onClick={onClick}>
              {intl.formatMessage(
                { defaultMessage: 'Compare with {company}' },
                { company: offerCompanyDisplayName ?? '' },
              )}
            </Button>
          ) : null
        }
        copy={insuranceDetailsCopy}
        bottomContent={
          <div className={styles.buttonsContainer}>
            {isComparisonPossible && skipIsCompare && (
              <Button
                style={{ marginTop: '32px' }}
                variant="tertiary"
                size="large"
                onClick={onClick}
                icon={<IconArrowRight width="32px" color={Color.green} aria-hidden />}
                iconPosition="right"
                center
                fullWidth
              >
                {intl.formatMessage(
                  { defaultMessage: 'Compare with {company}' },
                  { company: offerCompanyDisplayName },
                )}
              </Button>
            )}
            <Button
              style={{ marginTop: '32px' }}
              variant="secondary"
              size="small"
              onClick={() => navigate(-1)}
              center
              fullWidth
            >
              {intl.formatMessage({ defaultMessage: 'Back to result' })}
            </Button>
          </div>
        }
      />
    </BaseView>
  );
};
